import { Component } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent  {
  constructor(private location: Location) {}

  back() {
    this.location.back();
  }
}
